import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="calendar-tooltip"
export default class extends Controller {
  static targets = ["item", "tooltip", "content"]

  connect() {
    this.boundShowTooltip = this.showTooltip.bind(this)
    this.boundHideTooltip = this.hideTooltip.bind(this)
    this.boundMoveTooltip = this.moveTooltip.bind(this)

    this.itemTargets.forEach(item => {
      item.addEventListener("mouseenter", this.boundShowTooltip)
      item.addEventListener("mouseleave", this.boundHideTooltip)
      item.addEventListener("mousemove", this.boundMoveTooltip)
    })
  }

  disconnect() {
    this.itemTargets.forEach(item => {
      item.removeEventListener("mouseenter", this.boundShowTooltip)
      item.removeEventListener("mouseleave", this.boundHideTooltip)
      item.removeEventListener("mousemove", this.boundMoveTooltip)
    })
  }

  showTooltip(event) {
    const item = event.currentTarget
    const name = item.dataset.scheduleName
    const active = item.dataset.scheduleActive === "true"
    const displayable = item.dataset.scheduleDisplayable === "true"

    // Build tooltip content with improved styling
    let content = `<div class="font-semibold mb-2 text-gray-100">${this.escapeHtml(name)}</div>`
    content += `<div class="flex items-center gap-2 text-sm">`
    content += `<span class="inline-flex items-center gap-1.5"><span class="w-2 h-2 rounded-full ${active ? 'bg-frankly-olive-400' : 'bg-rose-400'}"></span>`
    content += `<span class="text-gray-300">${active ? 'Active' : 'Inactive'}</span></span>`
    content += `</div>`
    
    if (displayable) {
      content += `<div class="flex items-center gap-1.5 mt-2 text-frankly-olive-400 text-xs"><svg class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>Displayable</div>`
    } else {
      content += `<div class="flex items-center gap-1.5 mt-2 text-amber-400 text-xs"><svg class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/></svg>Not displayable</div>`
    }

    this.contentTarget.innerHTML = content
    this.tooltipTarget.classList.remove("hidden")
    this.positionTooltip(event)
  }

  hideTooltip() {
    this.tooltipTarget.classList.add("hidden")
  }

  moveTooltip(event) {
    this.positionTooltip(event)
  }

  positionTooltip(event) {
    const tooltip = this.tooltipTarget
    const offset = 10

    let left = event.clientX + offset
    let top = event.clientY + offset

    // Prevent tooltip from going off the right edge
    if (left + tooltip.offsetWidth > window.innerWidth) {
      left = event.clientX - tooltip.offsetWidth - offset
    }

    // Prevent tooltip from going off the bottom edge
    if (top + tooltip.offsetHeight > window.innerHeight) {
      top = event.clientY - tooltip.offsetHeight - offset
    }

    tooltip.style.left = `${left}px`
    tooltip.style.top = `${top}px`
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
